<!--
 * @Author: ymk
 * @Date: 2020-07-27 15:53:51
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 18:49:56
 * @FilePath: \car-demo\src\components\PintuanItem.vue
-->
<template>
	<div v-if="data" class="flex">
		<img
			class="pictrue"
			:style="{ width, height }"
			:src ="data.store_banner"

		alt="..."
		/>

		<ul>
			<li class="flex a-center">
				<span class="name">{{data.cat_id1}} {{data.goods_name}}</span>
				<span class="pink-tag">拼团</span>
			</li>
			<li class="text-grey">
				<del>￥{{data.shop_price}}</del> <span class="text-red">{{data.team_user_count}}人团：￥{{data.group_price}}</span>
			</li>
            <li>
                <span class="tag">{{data.cat_id2}}</span>
                <span class="tag">{{data.cat_id4}}</span>
                <span class="tag">{{data.time_long}}天拿本</span>
            </li>
            <li class="text-grey"><span v-if="data.store_name">{{ data.store_name.length > 6 ? data.store_name.slice(0,6) + '...' : data.store_name }}</span> | {{data.rname}}</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'pintuan-item',
	props: {
		width: {
			type: String,
			default: '100px',
		},
		height: {
			type: String,
			default: '75px',
		},
		data: {type: Object , required: false},
		borderBottom: Boolean,
	},
	computed: {
		borderBottomStyle() {
			if(this.borderBottom) {
				return {
					paddingBottom: '10px',
					borderBottom: '1px solid #E2E2E2',
				}
			}
		}
	},
	// mounted() {
	//
	// }
}
</script>

<style lang="less" scoped>
.pictrue {
	flex-shrink: 0;
	border-radius: 3px;
	margin-right: 10px;
}
ul {
	display: block;
	flex-grow: 1;
	// width: 70%;
}
ul li {
	&:not(:last-child) {
		margin-bottom: 10px;
	}
}
.name {
	.text-ellipsis();
	display: block;
	// width: 80%;
	// width: 45vw;
	color: #333333;
	font-size: 17px;
	font-weight: bold;
}
.address {
	.text-ellipsis();
	color: #999999;
	font-size: 13px;
}
.text-grey {
	width: 80%;
	float: left;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	color: #666666;
	font-size: 13px;
}
.text-red {
	color: #eb273b;
	font-size: 14px;
	margin-left: 5px;
}

.tag {
    .tag(@bg: #F8F8F8, @color: #666);
    border: 0;
}
.pink-tag {
	.tag(@bg:#FF808E, @color: #fff);
	min-width: 32px;
	text-align: center;
	margin-right: 0;
	margin-left: 5px;
}
.font-s {
	font-size: 12px;
	color: #333333;
}
</style>
